module.exports = __webpack_public_path__ + "media/customizations/reverie/back-6e155a95684dab4031a49585536237df.jpg";